module.exports = __webpack_public_path__ + "img/self-care.4abb96a5.jpg";